/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccessUserDto } from './accessUserDto';
import { AccessConfigDto } from './accessConfigDto';


export interface AccessDto { 
    access_token: string;
    refresh_token?: string;
    expires_at: number;
    user: AccessUserDto;
    accessConfig: AccessConfigDto;
    exchange_token?: string;
}

